import { bootstrapSystemOneWithoutRedux } from "./common/bootstrapSystemOne";

jQuery(() => {
  bootstrapSystemOneWithoutRedux(() => ({}));
});
